import { z } from "zod";

import { ExperienceProductDtoSchema } from "../../../../dtos/experience-products";
import { ExperienceVariationPricesDtoSchema } from "../../../../dtos/variation-prices";

export const PluginExperienceProductsSchema_2024_05_05 =
  ExperienceProductDtoSchema;
export type PluginExperienceProductsType_2024_05_05 = z.infer<
  typeof PluginExperienceProductsSchema_2024_05_05
>;

export const ProductVariantDtoSchema = z.object({
  id: z.string(),
  title: z.string().optional(),
  variationPrices: ExperienceVariationPricesDtoSchema.array().default([]),
});
export type PluginProductVariantType = z.infer<typeof ProductVariantDtoSchema>;

const PluginProductConfigSchema = z.object({
  id: z.string(),
  title: z.string().nullish().optional(),
  variants: ProductVariantDtoSchema.array(),
  handle: z.string().nullish().optional(),
  altHandles: z.record(z.string()).nullish().optional(),
  altIds: z.record(z.string()).nullish().optional(),
  image: z.string().nullish(),
  requiresSellingPlan: z.boolean().optional(),
});

export const PluginProductConfigSchema_2024_05_05 =
  ProductVariantDtoSchema.extend({
    variants: ProductVariantDtoSchema.array(),
    title: z.string().nullable().optional(),
  });

export type PluginProductConfigType_2024_05_05 = z.infer<
  typeof PluginProductConfigSchema_2024_05_05
>;
